import script from "./OMensagemAcordeao.vue?vue&type=script&lang=ts&setup=true"
export * from "./OMensagemAcordeao.vue?vue&type=script&lang=ts&setup=true"

import "./OMensagemAcordeao.vue?vue&type=style&index=0&id=2413add6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2413add6"]])

export default __exports__